import { registerComponent } from '@gig/magic-common';
import ExperimentComponent from './experiment.vue.js';

var Experiment = registerComponent(ExperimentComponent);

export { Experiment };
